<template>
  <div :class="isThirdStep? 'container f-bg-height-col-7':'container'">
    <v-stepper v-model="step" alt-labels>
      <div :class="isThirdStep? 'row u-justify-content-lg-flex-end':'row u-justify-content-flex-start'">
        <div class="col-12 col-lg-7 u-order-2 u-order-lg-1 full-height-bg" v-if="isThirdStep">
          <SystemOverview :system-name="systemName" :go-back="goBack"></SystemOverview>
        </div>
        <div :class="isFirstStep? 'u-display-none u-display-lg-block col-lg-3 u-order-2 u-order-lg-1':'col-12 col-lg-3 u-order-2 u-order-lg-1'" v-if="!isThirdStep">
          <BackButton :go-back="goBack" v-if="step === 2"></BackButton>
        </div>
        <div :class="isThirdStep? 'col-12 col-lg-5 u-order-1 u-order-lg-2 configuration-stepper':'col-12 col-lg-6 u-order-1 u-order-lg-2'">
          <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1">{{ $t('coldroom.select') }}</v-stepper-step>
            <v-divider :class="step >= 2 ? 'complete':''"></v-divider>
            <v-stepper-step :complete="step > 2" step="2">{{ $t('system.select') }}</v-stepper-step>
            <v-divider :class="step >= 3 ? 'complete':''"></v-divider>
            <v-stepper-step :complete="step > 3" step="3">{{ $t('size_design') }}</v-stepper-step>
            <v-divider :class="step === 4 ? 'complete':''"></v-divider>
            <v-stepper-step step="4"></v-stepper-step>
          </v-stepper-header>
        </div>
        <div :class="isThirdStep? 'col-12 col-lg-5 u-order-3':'col-12 u-order-3'">
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-container>
                <FirstStep :open-normal-temp="openNormalTemp" :open-low-temp="openLowTemp"></FirstStep>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-container v-if="this.step === 2">
                <SecondStep :open-classic="openClassic" :open-view="openView" :open-view-t="openViewT"></SecondStep>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="3">
              <ThirdStep v-if="this.step === 3"></ThirdStep>
            </v-stepper-content>
            <v-stepper-content step="4"></v-stepper-content>
          </v-stepper-items>
        </div>
      </div>
    </v-stepper>
  </div>
</template>

<style lang="scss">
@import './../sass/main.scss';
.steps {
  .v-stepper__content {
    padding: 0;
  }
}
.stepper {
  @include media-breakpoint-up(lg) {
    position: absolute;
    height: rem(100);
  }
}
.u-order-3 {
  @include media-breakpoint-up(lg) {
    padding-top: rem(100);
  }
}
.f-bg-height-col-7 {
  @include media-breakpoint-up(lg) {
    height: 100%;
    //min-height: 100vh;
    background: linear-gradient( to right, $color-s000 0%, $color-s000 57.5%, $color-white 57.5%, $color-white 100% );
    background: -webkit-linear-gradient( to right, $color-s000 0%, $color-s000 57.5%, $color-white 57.5%, $color-white 100% );
    background: -moz-linear-gradient( to right, $color-s000 0%, $color-s000 57.5%, $color-white 57.5%, $color-white 100% );
    background: -o-linear-gradient( to right, $color-s000 0%, $color-s000 57.5%, $color-white 57.5%, $color-white 100% );
    background: -ms-linear-gradient( to right, $color-s000 0%, $color-s000 57.5%, $color-white 57.5%, $color-white 100% );
    background-size: 99%;
    background-repeat: no-repeat;
    background-position: right;
  }
}
</style>

<script>
import FirstStep from  "./FirstStep.vue";
import SecondStep from  "./SecondStep.vue";
import SystemOverview from "./SystemOverview.vue";
import ThirdStep from "./ThirdStep.vue";
import BackButton from "./BackButton.vue";
import TrackingHelper from "../helpers/TrackingHelper";

export default {
  components: {
    FirstStep,
    SecondStep,
    SystemOverview,
    ThirdStep,
    BackButton
  },
  data() {
    return {
      step: 1,
      isThirdStep: false,
      systemName: null,
      systemDescription: null,
      isConfig: null,
      isResult: null
    };
  },
  computed: {
    isFirstStep: {
      get () {
        if (this.step === 1) {
          return true;
        } else {
          return false;
        }
      }
    }
  },
  mounted () {
    this.setRouteParams();
    this.trackVirtualPageview();
  },
  methods: {
    openNormalTemp () {
      this.step = 2;
      this.$store.commit('setColdroom', 'NT');
      this.trackVirtualPageview();
    },
    openLowTemp () {
      this.step = 3;
      this.coldroom = 'LT';
      this.$store.commit('setColdroom', 'LT');
      this.$store.commit('setColdroomSystem', 'classic');
      this.isThirdStep = true;
      this.systemName = 'Classic';
      this.trackVirtualPageview();
    },
    openClassic () {
      this.step = 3;
      this.$store.commit('setColdroomSystem', 'classic');
      this.isThirdStep = true;
      this.systemName = 'Classic';
      this.trackVirtualPageview();
    },
    openView () {
      this.step = 3;
      this.$store.commit('setColdroomSystem', 'view');
      this.isThirdStep = true;
      this.systemName = 'View';
      this.trackVirtualPageview();
    },
    openViewT () {
      this.step = 3;
      this.$store.commit('setColdroomSystem', 'tview');
      this.isThirdStep = true;
      this.systemName = 'T.View';
      this.trackVirtualPageview();
    },
    trackVirtualPageview () {
      let element = '';
      if (this.step === 1) {
        element = 'select coldroom'
      }else if (this.step === 2) {
        element = 'select normal temperatur system'
      } else if (this.step === 3) {
        element = `${this.systemName.toLowerCase()} system options`;
        if(this.coldroom === 'LT') {
          element += ' low temperature';
        } else {
          element += ' normal temperature';
        }
      }
      if (this.$store.getters.onlineTrackingEnabled) TrackingHelper.virtualPageview(element);
    },
    setRouteParams () {
      if (
        this.$route.params != undefined &&
        this.$route.params.step != undefined
      ) {
        this.step = this.$route.params.step;
        this.isThirdStep = this.$route.params.isThirdStep;
        this.systemName = this.$route.params.systemName;
      }
    },
    goBack() {
      if (this.$route.name === "First Steps") {
        if (this.step === 3) {
          this.isThirdStep = false;
          this.resetThirdStep();
        }
        if (this.$store.getters.coldroom === "LT") {
          this.step = 1;
        } else {
          this.step = this.step - 1;
        }
      }
      this.trackVirtualPageview();
    },
    resetThirdStep () {
      if(sessionStorage)sessionStorage.clear();
      this.$store.commit('setArticle', null);
      this.$store.commit('setBestSystem', undefined);
      this.$store.commit('setChosenItems', undefined);
      this.$store.commit('setColor', undefined);
      this.$store.commit('setComputedAccessoires', undefined);
      this.$store.commit('setContainerStops', undefined);
      this.$store.commit('setCutOutHeight', undefined);
      this.$store.commit('setCutOutWidth', undefined);
      this.$store.commit('setDividersPerShelf', undefined);
      this.$store.commit('setFrontStopsPerShelf', undefined);
      this.$store.commit('setGravitySheetSwitch', undefined);
      this.$store.commit('setKitFlanges', undefined);
      this.$store.commit('setNumberOfSystems', undefined);
      this.$store.commit('setPostsFrontBack', undefined);
      this.$store.commit('setShelvesPerDoor', undefined);
      this.$store.commit('setShelvesSingleDouble', undefined);
      this.$store.commit('setShelvesWirePlate', undefined);
      this.$store.commit('setSuggestedHeight', undefined);
      this.$store.commit('setTotalSystem', undefined);
    }
  }
};
</script>
